import {css} from 'lit'; export default css`.date-picker{width:290px}`;
    